import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2026 by Yun Sung Bin. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
